import PropTypes from "prop-types";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import Image from "../../../../components/image";
import Lightbox from "../../../../components/lightbox";
import { IMAGES_CONSTANTS } from "../../../../config/constants/images-constants";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import useResponsive from "src/hooks/useResponsive";

DetailsGallery.propTypes = {
  images: PropTypes.array,
};

export default function DetailsGallery({ images }) {
  const theme = useTheme();
  const [selectedImage, setSelectedImage] = useState(-1);
  const [imagesHaveApiCompression, setImagesHaveApiCompression] = useState(true);
  const isMobile = useResponsive("down", "sm");
  const THUMB_SIZE = isMobile ? 125 : 192;


  const imagesLightbox = images.map((img) => ({ src: img }));

  const handleOpenLightbox = (imageUrl) => {
    const index = imagesLightbox.findIndex((image) => image.src === imageUrl);
    setSelectedImage(index);
  };

  const handleCloseLightbox = () => setSelectedImage(-1);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          overflowY: "hidden",
          gap: 1,
          pb: 1,
          mb: 4,
          maxWidth: "100%",
        }}
      >
        {images.map((img) => (
          <Box
            key={img}
            sx={{
              flex: "0 0 auto",
              width: THUMB_SIZE,
              aspectRatio: "2 / 3",
              cursor: "pointer",
              borderRadius: 1.5,
              overflow: "hidden",
            }}
            onClick={() => handleOpenLightbox(img)}
          >
            <Image
              disabledEffect
              alt="thumbnail"
              src={`${img}${imagesHaveApiCompression
                  ? `@${IMAGES_CONSTANTS.THUMBNAIL_SIZE_WEB}`
                  : ""
                }`}
              onError={() => setImagesHaveApiCompression(false)}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </Box>

      <Lightbox
        index={selectedImage}
        slides={imagesLightbox}
        open={selectedImage >= 0}
        close={handleCloseLightbox}
        plugins={[Fullscreen]}
      />
    </>
  );
}
